import useGetDataWithAxios from "./hooks/useGetDataWithAxios";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import MainPage from "./components/MainPage/MainPage";
import SimplePagePreview from "./components/SimplePagePreview/SimplePagePreview";
import PageWithSupagesPreview from "./components/PageWithSupagesPreview/PageWithSupagesPreview";
import SubPagePreview from "./components/SubPagePreview/SubPagePreview";
import RouterWrapper from "./RouterWrapper";

function App() {
 // eslint-disable-next-line
  const {getData, data, errors} = useGetDataWithAxios("http://85.122.26.5:5000/pages/get_pages");
  const {getData: getSubpages, data: subpages, errors: err} = useGetDataWithAxios("http://85.122.26.5:5000/subpages/get_subpages")

  const website_language = localStorage.getItem("website_language");

  useEffect(() => {
    getData();
    getSubpages();

    if(!website_language) {
      localStorage.setItem("website_language", "RO")
    }
     // eslint-disable-next-line
  }, []);

  window.onpopstate = () => {
    alert('reloading')
  }

  return (
    <div className="font-poppins h-[100vh]">
      {errors && console.log(errors)}
      <Router>
        <RouterWrapper pages={data} subpages={subpages} website_language={website_language!} />
      </Router>
    </div>
  );
}

export default App;
